const Allergens = () => import("./views/Allergens.vue");
const AllergenEdit = () => import("./views/AllergenEdit.vue");
const AllergensGroups = () => import("./views/AllergensGroups.vue");
const AllergensGroupEdit = () => import("./views/AllergensGroupEdit.vue");

const allergensRoute = "/allergens";
const allergensGroupsRoute = "/allergensGroups";

export default [
  {
    path: allergensRoute,
    name: "allergens.list",
    component: Allergens,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${allergensRoute}/create`,
    name: "allergens.create",
    component: AllergenEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${allergensRoute}/:allergenId/edit`,
    name: "allergens.edit",
    component: AllergenEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: allergensGroupsRoute,

    name: "allergensGroups.list",
    component: AllergensGroups,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${allergensGroupsRoute}/create`,
    name: "allergensGroups.create",
    component: AllergensGroupEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${allergensGroupsRoute}/:allergensGroupId/edit`,
    name: "allergensGroups.edit",
    component: AllergensGroupEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },
];
